const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfStrength extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfStrength,
            "Each civilizations score culture according to their relative strength:/n" + 
            "4 players: 15/10/5/0 culture;\n" + 
            "3 players: 14/7/0 culture;\n" + 
            "2 players: 10/0 culture;\n" + 
            "(In case of ties see the rules)",
            {}
        )
    }
}

module.exports = ImpactOfStrength;